<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="hrEmployee" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" height="600" :border="true">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column prop="Name" label="姓名"></el-table-column>
      <el-table-column prop="Code" label="工号"></el-table-column>
      <el-table-column prop="DeptName" label="部门"></el-table-column>
      <el-table-column prop="WorkStatusDesc" label="在职状态"></el-table-column>

      <el-table-column prop="Education" label="学历"></el-table-column>
      <el-table-column prop="Mobile" label="手机号"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间"  ></el-table-column>
      <el-table-column prop="CreateUser" label="创建者"></el-table-column>
      <el-table-column prop="Status" label="状态" width="">
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canEdit" type="primary" @click="() => {
              currentRow = scope.row;
              handleEdit();
            }
            ">
            编辑
          </el-link>
          <el-link v-if="canDelete" type="danger" @click="() => {
              sels.push(scope.row);
              handleDel();
            }
            ">
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
        <el-form-item label="姓名" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="Mobile">
          <el-input v-model="editForm.Mobile" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="Address">
          <el-input v-model="editForm.Address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="Education">
          <el-input v-model="editForm.Education" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="Code">
          <el-input v-model="editForm.Code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="在职状态" prop="WorkStatus">
          <el-select v-model="editForm.WorkStatus" placeholder="请选择状态">
            <el-option label="实习" :value="0"></el-option>
            <el-option label="试用" :value="1"></el-option>
            <el-option label="正式" :value="2"></el-option>
            <el-option label="临时" :value="3"></el-option>
            <el-option label="离职" :value="4"></el-option>
            <el-option label="退休" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="DeptName">
          <el-input v-model="editForm.DeptName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="岗位">
          <el-input v-model="editForm.HrPostName" class="input-dialogname" readonly />
          <el-button type="primary" @click="visibleHrPostDialog = true" :loading="editLoading">
            选择
          </el-button>
        </el-form-item>
        <el-form-item label="入职时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="editForm.EmployeDate"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="转正时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="editForm.PostiveDate"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="离职时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="editForm.QuitDate"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="归档" :value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="editForm.Remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <el-form-item label="姓名" prop="Name">
          <el-input v-model="addForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="Mobile">
          <el-input v-model="addForm.Mobile" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="Address">
          <el-input v-model="addForm.Address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="学历" prop="Education">
          <el-input v-model="addForm.Education" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="工号" prop="Code">
          <el-input v-model="addForm.Code" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="在职状态" prop="WorkStatus">
          <el-select v-model="addForm.WorkStatus" placeholder="请选择状态">
            <el-option label="实习" :value="0"></el-option>
            <el-option label="试用" :value="1"></el-option>
            <el-option label="正式" :value="2"></el-option>
            <el-option label="临时" :value="3"></el-option>
            <el-option label="离职" :value="4"></el-option>
            <el-option label="退休" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门">
          <el-input v-model="addForm.DeptID" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="岗位">
          <el-input v-model="addForm.HrPostName" class="input-dialogname" readonly />
          <el-button type="primary" @click="visibleHrPostDialog = true" :loading="editLoading">
            选择
          </el-button>
        </el-form-item>
        <el-form-item label="入职时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.EmployeDate"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="转正时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.PostiveDate"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="离职时间">
          <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.QuitDate"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input type="textarea" v-model="addForm.Remark" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <TableDataDialog title="岗位选择" :visibleDialog="visibleHrPostDialog" :queryMethod="queryData" :columns="{
      Name: {
        label: '岗位名称',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @callback="dialogCallback" @getDialogVisible="setVisible"></TableDataDialog>
  </section>
</template>

<script>
//引入hrEmployee.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/hrEmployee";
import { getHrPostListPage } from "../../api/hrPost";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";

export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      hrEmployee: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Name: "",
        Mobile: "",
        Address: "",
        Education: "",
        Code: "",
        WorkStatus: "",
        DeptID: 0,
        DeptName: "",
        HrPostID: 0,
        HrPostName: "",
        EmployeDate: "",
        PostiveDate: "",
        QuitDate: "",
        Remark: "",
        Status: 0,
      },
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Name: "",
        Mobile: "",
        Address: "",
        Education: "",
        Code: "",
        WorkStatus: "",
        DeptID: 0,
        DeptName: "",
        HrPostID: 0,
        HrPostName: "",
        EmployeDate: "",
        PostiveDate: "",
        QuitDate: "",
        Remark: "",
      },
      visibleHrPostDialog: false,
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getHrEmployee();
    },
    //获取岗位列表
    getHrEmployee() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getHrEmployeeListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.hrEmployee = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeleteHrEmployee(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getHrEmployee();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateUser: "",
      };
    },
    //执行编辑
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;

          let para = Object.assign({}, this.editForm);
          let user = JSON.parse(window.localStorage.user);
          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "用户信息为空，先登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          api
            .editHrEmployee(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getHrEmployee();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.editLoading = false;
            });
        }
      });
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          api
            .addHrEmployee(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getHrEmployee();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getHrEmployee();
    },
    dialogCallback(data) {
      if (data.length > 0) {
        this.addForm.HrPostName = data[0].Name;
        this.addForm.HrPostID = data[0].Id;
        this.editForm.HrPostName = data[0].Name;
        this.editForm.HrPostID = data[0].Id;
      }
      this.visibleHrPostDialog = false;
    },
    queryData(params) {
      return getHrPostListPage(params);
    },
    setVisible(val) {
      this.visibleHrPostDialog = val;
    },
  },
  mounted() {
    this.getHrEmployee();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped>
.input-dialogname {
  width: 300px;
}
</style>
